var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-content-center"},[_c('button',_vm._b({staticClass:"estage-modal-form-btn d-flex align-items-center gap-[14px]",attrs:{"disabled":_vm.loading,"type":"submit"},on:{"click":() => _vm.$emit('click')}},'button',_vm.$attrs,false),[_vm._t("default"),(_vm.loading)?_c('b-spinner',{attrs:{"small":""}}):_vm._e()],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }